import React from "react";

export default function Footer() {
  return (
    <div className="pp-footer">
      <div className="container">
        <div className="d-flex justify-content-between">
          <div className="text-muted">
            {" "}
            Copyright © 2021. All Rights Reserved by Shield Network
          </div>
          <div className="text-muted"> v1.2.0</div>
          <div className="text-end pp-footer-link">
            {/* <a
              target="_blank"
              rel="noreferrer"
              href="https://bscpad.com/privacy-policy"
            >
              Privacy Policy{" "}
            </a>
            <a
              target="_blank"
              rel="noreferrer"
              href="https://bscpad.com/terms-of-use"
            >
              Terms of Use{" "}
            </a> */}
          </div>
        </div>
      </div>
    </div>
  );
}
